import cn from 'classnames';
import { FunctionComponent, JSX } from 'preact';

import { isTouchDevice } from '../../../../utils/device';
import { ToggleSoundButton } from '../buttons/ToggleSoundButton';
import { VolumeSlider } from '../VolumeSlider/VolumeSlider';

interface VolumeButtonProps {
  className?: Exclude<
    JSX.HTMLAttributes<HTMLButtonElement>['className'],
    JSX.SignalLike<any>
  >;
}

export const VolumeButton: FunctionComponent<VolumeButtonProps> = ({
  className,
}) => {
  const isVolumeSliderSupported = !isTouchDevice;

  return (
    <div className={cn('vgp-volume-button', className)}>
      <ToggleSoundButton />
      {isVolumeSliderSupported && (
        <div className="vgp-volume-panel">
          <VolumeSlider />
        </div>
      )}
    </div>
  );
};
